export enum MouseClick { 
    Left   = 0, 
    Middle = 1,
    Right  = 2
}
